import { API } from './resources'

export default {
  getRegions: () => {
    return API.get('/provinces')
  },
  addProjectToRegion: (projectID, regionID) => {
    return API.post(`/region/${regionID}/project/${projectID}`)
  },
  updateLogo: (data) => {
    return API.post('/region/updateLogo', data)
  }
}
